import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { _throw } from 'rxjs/observable/throw';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

// Backend routes that don't sit behind the auth+authenticate middleware chain
// (see otc_admin_backend/routes/index.js) - a 401/409 from one of these is a
// normal login/forgot-password domain error (wrong password, wrong OTP, etc.),
// not a sign that an authenticated admin session was invalidated.
const PUBLIC_ENDPOINTS = [
  '/csrf',
  '/countrylistadmin',
  '/adminmobilecode',
  '/setpassword',
  '/checkpasswordgeneration',
  '/accountverify',
  '/verifyMailIdadmin',
  '/sendfpwcode',
  '/setforgetpasswordal',
  '/adminlogin'
];

// Every other route requires authenticate middleware, which returns 401 (bad/
// expired/superseded JWT - including the session_id mismatch when the admin
// logged in elsewhere) or 409 (account disabled/deleted) - in every one of
// those cases the right move is to drop the stale session and go to login.
@Injectable()
export class SessionExpiredInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isPublic = PUBLIC_ENDPOINTS.some((path) => req.url.endsWith(path));

    return next.handle(req).pipe(
      catchError((error) => {
        if (!isPublic && error && (error.status === 401 || error.status === 409)) {
          window.localStorage.removeItem(environment.TOKEN_SECRET);
          window.localStorage.removeItem('permission');
          this.router.navigateByUrl('/index');
        }
        return _throw(error);
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptors/session-expired.interceptor.ts